import { observeElement, getWidget } from '@uvocore-front/utils';
import htmlTemplate from './htmlTemplate';

import './style.scss';

observeElement({
  element: '[data-testimonials-list]',
  marginValue: 200,
  callback: () => {
    getWidget({
      widgetLink: '/assets/js/testimonialsWidget.min.js',
      insertLoaderTo: '[data-testimonials-list]',
      loader: false,
      fn: () => {
        observeElement({
          element: '[data-testimonials-list]',
          marginValue: 200,
          callback: () => {
            window.tmWidget({
              params: {
                siteId: 61,
                limit: 8,
                minBodyLength: 0,
              },
              template: htmlTemplate,
              type: 'html',
              moreEl: '.section-testimonials-page__btn',
              containerEl: '[data-testimonials-list]',
              loader: true,
            });
          },
        });
      },
    });
  },
});
